import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../services/api";
// Async Thunks

export const login = createAsyncThunk(
  "user/login",
  async (loginFormData, { rejectWithValue }) => {
    console.log(loginFormData);
    try {
      const { data } = await api.post("/login", loginFormData);
      return data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// 🔐 Auth Thunks

export const register = createAsyncThunk(
  "user/register",
  async (userData, { rejectWithValue }) => {
    try {
      console.log(userData);
      const { data } = await api.post("/register", userData);
      return data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const loadUser = createAsyncThunk(
  "user/loadUser",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/me");
      console.log(data);
      return data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const logout = createAsyncThunk(
  "user/logout",
  async (_, { rejectWithValue }) => {
    try {
      await api.get("/logout");
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateProfile = createAsyncThunk(
  "user/updateProfile",
  async (userData, { rejectWithValue }) => {
    try {
      const { data } = await api.put("/me/update", userData);
      return data.success;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updatePassword = createAsyncThunk(
  "user/updatePassword",
  async (passwords, { rejectWithValue }) => {
    try {
      const { data } = await api.put("/password/update", passwords);
      return data.success;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "user/forgotPassword",
  async (email, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/password/forgot", email);
      return data.message;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateUpiId = createAsyncThunk(
  "user/updateUpiId",
  async ({ userId, upiId }, { rejectWithValue }) => {
    try {
      const { data } = await api.put("/update-upi", { userId, upiId });
      console.log(userId, upiId);
      return data.message;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async ({ token, passwords }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/password/reset/${token}`, passwords);
      return data.success;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// 🛠️ Admin Thunks

export const getAllUsers = createAsyncThunk(
  "user/getAllUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/admin/users");
      console.log(data.users, "user");
      return data.users;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getUserDetails = createAsyncThunk(
  "user/getUserDetails",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/admin/user/${id}`);
      return data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async ({ id, userData }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/admin/users/${id}`, userData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/admin/users/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Get admin users only
export const getAdminUsers = createAsyncThunk(
  "user/getAdminUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/admin/users/admins");
      return { users: data.users, role: "admin" };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Get distributor users only
export const getDistributorUsers = createAsyncThunk(
  "user/getDistributorUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/admin/users/distributors");
      return { users: data.users, role: "distributor" };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Get vendor users only
export const getVendorUsers = createAsyncThunk(
  "user/getVendorUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/admin/users/vendors");
      return { users: data.users, role: "vendor" };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Get regular users only
export const getRegularUsers = createAsyncThunk(
  "user/getRegularUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/admin/users/regular");
      return { users: data.users, role: "user" };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Get outstanding payments for logged-in user
// Params: { startDate, endDate } (optional) - e.g. { startDate: '2025-12-01', endDate: '2025-12-31' }
export const getMyOutstandingPayments = createAsyncThunk(
  "user/getMyOutstandingPayments",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();
      if (params.startDate) query.set("startDate", params.startDate);
      if (params.endDate) query.set("endDate", params.endDate);
      const qs = query.toString();
      const url = qs ? `/me/outstanding-payments?${qs}` : "/me/outstanding-payments";
      const { data } = await api.get(url);
      return data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
  {
    condition: (_, { getState }) => !getState().user.loading,
  }
);

// Get outstanding payments for a specific user (admin only)
export const getUserOutstandingPayments = createAsyncThunk(
  "user/getUserOutstandingPayments",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/admin/users/${userId}/outstanding-payments`);
      return { userId, userName: data.userName, payments: data.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
// Slice

const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: false,
    isAuthenticated: false,
    user: null,
    users: [],
    adminUsers: [],
    distributorUsers: [],
    vendorUsers: [],
    regularUsers: [],
    userDetails: null,
    isUpdated: false,
    isDeleted: false,
    message: null,
    success: false,
    error: null,
    outstandingPayments: null, // null means not fetched yet, [] means fetched but empty
    userOutstandingPayments: null,
  },
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    },
    resetUpdate: (state) => {
      state.isUpdated = false;
    },
    resetDelete: (state) => {
      state.isDeleted = false;
    },
    clearMessage: (state) => {
      state.message = null;
    },
    resetSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    // Existing reducers ...

    // LOGIN
    builder.addCase(login.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = action.payload;
    });

    // REGISTER
    builder.addCase(register.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(register.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(register.rejected, (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = action.payload;
    });

    // LOAD USER
    builder.addCase(loadUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(loadUser.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(loadUser.rejected, (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload;
    });

    // LOGOUT
    builder.addCase(logout.fulfilled, (state) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
    });

    // UPDATE PROFILE
    builder.addCase(updateProfile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.isUpdated = action.payload;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // UPDATE PASSWORD
    builder.addCase(updatePassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updatePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.isUpdated = action.payload;
    });
    builder.addCase(updatePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // FORGOT PASSWORD
    builder.addCase(forgotPassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload;
    });
    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // RESET PASSWORD
    builder.addCase(resetPassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.success = action.payload;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updateUpiId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateUpiId.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(updateUpiId.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // ADMIN
    builder.addCase(getAllUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.users = action.payload;
    });
    builder.addCase(getAllUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getUserDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.userDetails = action.payload;
    });
    builder.addCase(getUserDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(updateUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.loading = false;
      state.isUpdated = action.payload;
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.loading = false;
      state.isDeleted = action.payload.success;
      state.message = action.payload.message;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // GET ADMIN USERS
    builder.addCase(getAdminUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAdminUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.adminUsers = action.payload.users;
      state.users = action.payload.users; // Also update main users array
      state.currentFilter = "admin";
      state.error = null;
    });
    builder.addCase(getAdminUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // GET DISTRIBUTOR USERS
    builder.addCase(getDistributorUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDistributorUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.distributorUsers = action.payload.users;
      state.users = action.payload.users; // Also update main users array
      state.currentFilter = "distributor";
      state.error = null;
    });
    builder.addCase(getDistributorUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // GET VENDOR USERS
    builder.addCase(getVendorUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getVendorUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.vendorUsers = action.payload.users;
      state.users = action.payload.users; // Also update main users array
      state.currentFilter = "vendor";
      state.error = null;
    });
    builder.addCase(getVendorUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // GET REGULAR USERS
    builder.addCase(getRegularUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getRegularUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.regularUsers = action.payload.users;
      state.users = action.payload.users; // Also update main users array
      state.currentFilter = "user";
      state.error = null;
    });
    builder.addCase(getRegularUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // GET MY OUTSTANDING PAYMENTS
    builder.addCase(getMyOutstandingPayments.pending, (state) => {
      // Only set loading if not already loading to prevent duplicate calls
      if (!state.loading) {
        state.loading = true;
        state.error = null;
      }
    });
    builder.addCase(getMyOutstandingPayments.fulfilled, (state, action) => {
      state.loading = false;
      // Only update if we got valid data
      if (Array.isArray(action.payload)) {
        state.outstandingPayments = action.payload;
      } else if (!state.outstandingPayments || state.outstandingPayments.length === 0) {
        state.outstandingPayments = [];
      }
      state.error = null;
    });
    builder.addCase(getMyOutstandingPayments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // GET USER OUTSTANDING PAYMENTS (ADMIN)
    builder.addCase(getUserOutstandingPayments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserOutstandingPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.userOutstandingPayments = action.payload;
    });
    builder.addCase(getUserOutstandingPayments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const {
  clearErrors,
  resetUpdate,
  resetDelete,
  clearMessage,
  resetSuccess,
} = userSlice.actions;
export default userSlice.reducer;
